interface Props {
    name: string | undefined;
}

export const ExperienceName = ({ name }: Props): React.ReactElement => {
    return (
        <>{name || 'No experience name available'}</>
    )
}